import { TransactionInput } from "models/Order";

export interface OptionsDownloadInLotProps {
  handleCloseDownloadInLot: () => void;
  titleRequestDownload?: string;
  messageRequestDownload?: string;
  selectedOrderDownloadInLot: TransactionInput[];
}

export const DownloadInLotTypes = {
  BILLET: 0,
  INVOICE: 3,
  RECEIPT: 4,
  INVOICE_XML: 6,
  INVOICE_SHIPPING: 9,
  INVOICE_SHIPPING_XML: 10,
  RECEIPT_SHIPPING: 13,
  ELECTRONIC_BILL_LADING: 15,
  ELECTRONIC_BILL_LADING_XML: 16
};

export const DownloadType = {
  ORDER: 0,
  CTE: 1
};